import React from 'react';
import TaskCard from './TaskCard';
import { useState, useEffect } from 'react';
import toast from 'react-hot-toast';
import { useClient } from 'jsonapi-react';
import { t } from 'i18next';
import { EmptyState } from '@/components/custom/empty-state';
import { Widget, WidgetBody, WidgetHeader, WidgetTitle } from '@/components/custom/widget';

export default function TaskWidget(props) {
  const { currentCourse } = props;
  const [tasks, setTasks] = useState([]);
  const client = useClient();

  const getTasks = async () => {
    const { data, error } = await client.fetch(`/slots?filter[master_slots.slotable_type]=Course&filter[master_slots.slotable_id]=${currentCourse?.id}`);
    if (error) {
      toast.error('Erro ao carregar tarefas');
    } else {
      setTasks(data);
    }
  };

  useEffect(() => {
    getTasks();
  }, []);

  if (tasks.length === 0) {
    return (
      <EmptyState
        type="data"
        title="Ainda não existem tarefas."
      />
    );
  }

  return (
    <Widget className="mb-6">
      <WidgetHeader>
        <WidgetTitle>{t('events.todayTasks')}</WidgetTitle>
      </WidgetHeader>

      <WidgetBody style={{ display: 'flex', flexDirection: 'column', gap: '12px', overflowY: 'auto', overflowX: 'hidden', maxHeight: '280px', paddingRight: '8px', marginRight: '-8px' }}>
        {tasks.map(task => (
          <TaskCard
            task={task}
            key={task.id}
          />
        ))}
      </WidgetBody>
    </Widget>
  );
}
